var Global_RenderedFormTypeId = 0;//TrlObjectTypeId of rendered form
var hasMilitaryTimeFormat = true;

/* JS shared between TB, TE and TM to be entered here */

//---------------------------------------------------------
//----------------------Menu Functions --------------------
//---------------------------------------------------------

// detect browser close and naviagtion to other domains
// use beforeunload event together with navigation handlers

// set this to true, if navigation was triggered by one of our page controls
var wasVaildNavigationCall = false;

window.onbeforeunload = function () {
    if (!wasVaildNavigationCall) {
        // implement handlers here
    }
    wasVaildNavigationCall = false;
};

// Attach the event click for all links in the page
$("a").on("click", function () {
    TryResetMenuTimer('link click');
    wasVaildNavigationCall = true;
});

// Attach the event click for all inputs in the page
$("input[type=submit]").on("click", function () {
    TryResetMenuTimer('input submit');
    wasVaildNavigationCall = true;
});

// catch key event for:
// a)- backspace; in IE this triggers a back navigation, which is not handled in unload event
// suppress on all controls, which do not allow text modification
// this code is only needed for IE, but there is no need to make it browser specific

// b) activate enter key to trigger primary button click on pages and modal dlgs..
$(document).on('keydown', function (e) {
    var $target = $(e.target || e.srcElement);    

	// handle "enter"
    if (e.keyCode == 13) {
    	// check if popup is on dlg and has prime button -> use this
        var $popUpBtn = $('.popupMessage').siblings('.dialogFooter').find('.btn-primary');
        if ($popUpBtn != null && $popUpBtn.length == 1 && !$popUpBtn.is(':disabled')) {
    		TriggerPrimeButtonClick($popUpBtn, $target);
    		return false;
    	}else{
            var $focusedEl = $(":focus"); // check if any other than prime button has focus- > "click" it
            if($focusedEl.length > 0 && !$focusedEl.is(':disabled') && ($focusedEl.hasClass('btn-tertiary') || $focusedEl.hasClass('btn-secondary')) ){
                TriggerPrimeButtonClick($focusedEl, $target);
            }
            else {
                var $formBtn = $(".btn-primary");
    		    if ($formBtn.length == 1 && !$formBtn.is(':disabled')) {
    			    TriggerPrimeButtonClick($formBtn, $target);
    			    return false;
    		    }
            }
    	}
	}
});

function TriggerPrimeButtonClick($btn, $target){
	if (!$target.is('textarea')) {
		$btn.trigger("click");
		return false;
	}
}

function Logout(reasonId) {
    if (reasonId == null)
        reasonId = 0;

    $("[name='sessionlogoutReason']").val(reasonId);
    $('#logoutForm').trigger("submit");
}

// try to reset the menu timer
function TryResetMenuTimer(alertText) {
    try {
        if (ResetMenuTimer && typeof (ResetMenuTimer) == "function") {
            ResetMenuTimer(alertText);
        }
    }
    catch (err) { // ignore error
    }
}

//----------------------------------------------------------------------
// Redirect Functions
//----------------------------------------------------------------------
// Resets the 'isFormModified' flag which was involuntarily set due to the javascript call
function ResetButtonFrame() {
    sessionStorage.isFormModified = false;
}

var isClicked = false;
function RedirectToContentFrameFromReportingGridLink(gridName, controllerName, uniqueGridId, id, url) {
    RedirectToContentFrame(id, url);
}

function RedirectToContentFrame(id, url) {
    if (isClicked == null || isClicked)
        return;

    var obj = $("#" + id);
    if (obj == null || obj.disabled)
        return;

    NavigateAway(url);
}
function RedirectToContentFrameCallback(obj) {
    isClicked = true;
    obj.onclick = disabledLinkClick;
    obj.disabled = true;
    obj.style.cursor = "default";
}
function disabledLinkClick() {
    return false;
}

function replaceDivBody(url){
    Kendo_ShowOrHideLoadingImage("divMain", true);
    $.ajax({
            url: url,
            method: "GET",
            success: function (result) {
				if (PanelSelection_ResetRenderedForm && typeof (PanelSelection_ResetRenderedForm) == "function")//this will exist in TM only
					PanelSelection_ResetRenderedForm();//we don't know what will be rendered in divBodyRender - if form, we'll set the ID on callback
                if ($(result).find("#divBodyRender").length > 0)
                    result = $(result).find("#divBodyRender");
                $("#divBodyRender").html(result);
                if (typeof (PanelSelection_ShowOrHideActionButtons) == "function")
                    PanelSelection_ShowOrHideActionButtons();
                Kendo_ShowOrHideLoadingImage("divMain", false);
            },
            error: function (result) {
                Kendo_ShowOrHideLoadingImage("divMain", false);
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
}

//----------------------------------------------------------------------
// Functions accessing MenuFrame objects
//----------------------------------------------------------------------

//// Retrieve the saved Web location
function GetLocation() {
    return sessionStorage.urlRef;
}

// Save the 'url' Web location for future reference
function SaveLocation(url) {
    sessionStorage.urlRef = url;
}

// Save location and append a parameter indicating return
function SaveLocationAppendReturnFlag(url) {
    if (url.indexOf('ret=1') < 0) {
        if (url.indexOf('?') > 0)
            url += '&ret=1';
        else
            url += '?ret=1';
    }
    SaveLocation(url);
}

// Checks if the system is logged out
function IsLogout() {
    if (sessionStorage && sessionStorage.isSystemLoggedOut != "null" && sessionStorage.isSystemLoggedOut != undefined && sessionStorage.isSystemLoggedOut != "undefined")
        return (sessionStorage.isSystemLoggedOut == "true");
    return false;
}

//----------------------------------------------------------------------
// date and Help Functions
//----------------------------------------------------------------------
function GetCurrentTimeToTimer(dt) {
    try {
        // Get date
        var fDate = GetFormattedDate(dt, "YMD");

        // Get time
        var hh = dt.getHours();
        var mm = dt.getMinutes();
        var ss = dt.getSeconds();
        var sfx = "";

        // TODO: should check whether to format with AM/PM if (isAM != null)
        if (!hasMilitaryTimeFormat) {
            if (hh > 11) {
                hh -= 12;
                sfx = "PM";
            }
            else
                sfx = "AM";
            if (hh == 0)
                hh = 12;
        }

        var res = FormatDD(hh);
        res = res + ':' + FormatDD(mm);
        res = res + ':' + FormatDD(ss);
        fDate = fDate + " " + res + " " + sfx;
        return fDate;
    }
    catch (ex) {
        return dt.toUTCString();
    }
}

function SetHelpTopicId(helpIdx) {
    helpIdx = helpIdx;
}

function SetHelpRoleId(helpRoleId) {
    helpRoleIdx = helpRoleId;
}

// for textarea we need a similar limit for maxlength as textbox has
function LimitTextAreaLen(obj) {
    var maxlen = obj.getAttribute("maxLength");
    // additional check added for IE10
    // "maxLength" does not show in the obj collection through getAttribute or casting to jQuery for .attr
    // accessing the collection directly until research can determine the proper way to handle IE10
    if (maxlen == null)
        maxlen = obj.attributes("maxLength").value;
    if (maxlen != null && maxlen != "") {
        var mlength = parseInt(maxlen, 10);
        if (obj.value.length > mlength)
            obj.value = obj.value.substring(0, mlength)
    }
}

//prepends with leading 0
function FormatDD(d) {
    if (d == '0' || d == '1' || d == '2' || d == '3' || d == '4' || d == '5' || d == '6' || d == '7' || d == '8' || d == '9')
        return '0' + d;

    return d;
}
function trim_x(str) { return str.replace(/^\s+|\s+$/g, '').replace(/\s/, 'x'); };

// Backspace navigation can cause problems on certain pages - but needs to be allowed if it was pressed in a text field or area
function AvoidBackspaceNavigation(e) {

    var theEvent = window.event || arguments[0]; // window.event is for IE arguments[0] is for FF
    var kc = theEvent.keyCode;

    if (window.event)
        e = window.event;

    var theSrcElement = e.srcElement ? e.srcElement : e.target; // e.target is for FF
    var t = theSrcElement.type;

    var shouldNotBlock = (kc != 8 && kc != 13) || (t == 'text' && kc != 13) || (t == 'textarea') || (t == 'submit' && kc == 13);

    if (e.preventDefault && !shouldNotBlock) // FF
        e.preventDefault();
    else
        return shouldNotBlock;  // IE
}

function GridCreated(sender, args) {
    var scrollArea = sender.GridDataDiv;
    var dataHeight = sender.get_masterTableView().get_element().clientHeight;
    if (dataHeight < 350) {
        scrollArea.style.height = dataHeight + "px";
    }
}

// function to convert string "true" or "false" to boolean
function returnBoolean(value) {
    if (value === true || value.toString().toLowerCase() == 'true')
        return true;
    if (value === false || value.toString().toLowerCase() == 'false')
        return false;
    return false;
}

// HTML encode & decode support -> easy methods to invert Server-side HttpUtility.HtmlEncode and HttpUtility.HtmlDecode methods
function HtmlEncode(value) {
    //create a in-memory div, set it's inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return $('<div/>').text(value).html();
}

function HtmlDecode(value) {
    return $('<div/>').html(value).text();
}

// check that text does not contain any undesired HTML tags
function ValidateNoHtml(text) {
    return !text.match(/<\/*[a-z][^>]+?>/gi);
}

// ensure all  buttons with attribute equalwidth='true' have same (max) width
function EqualButtonsWidth() {
    var allWidth = 0;
    $("[equalwidth='true']").each(function () {
        if ($(this).width() > allWidth)
            allWidth = $(this).width();
    });
    $("[equalwidth='true']").each(function () {
        $(this).width(allWidth);
    });
}

function getPageName(url) {
    var index = url.lastIndexOf("/") + 1;
    var filename = url.substr(index);
    return filename;
}

function ClearSessionStorage() {
    sessionStorage.clear();
}

function CloseModal(uniquePopupId, removeCloseEvent) {
    //use removeCloseEvent when you wish to prevent "close" event execution (onClose function execution)
    if (uniquePopupId != null && uniquePopupId != undefined && uniquePopupId.length === 0)
        uniquePopupId = "popupWindow";
    if (removeCloseEvent == null || removeCloseEvent == undefined || typeof (removeCloseEvent) != "boolean")
        removeCloseEvent = false;
    if ($("#" + uniquePopupId).length > 0) {
        var currenModalWindow = $("#" + uniquePopupId).data("kendoWindow");
        if (currenModalWindow && removeCloseEvent) {
            currenModalWindow.unbind("close");
        }
        currenModalWindow.close();
        currenModalWindow.destroy(); // destroy method tries to remove Dom elements inside the modal. In case of ListBox, kendo's modal instance not able to find ListBox reference and hence causing removeData of null error.
    }
    //Remove the Id from the list of popupWindosIds
    popupWindosIds.splice($.inArray(uniquePopupId, popupWindosIds), 1);
}

function CloseModelPopup(removeCloseEvent) {
    CloseModal("popupWindow", removeCloseEvent);
}

var popUpWindow;
//List of all modal popups ids created
var popupWindosIds = [];

function showInModalWithOptions(surl, options, ctrl) {
    showInModal(surl, undefined, ctrl, options);
}

function showInModal(surl, useDefaultForMinMaxHeight, ctrl, options) {
    if (IsControlActionAlreadyExecuted(ctrl))
        return;
    Kendo_ShowOrHideLoadingImage("divMain", true);
    var request = $.ajax({
        url: surl,
        method: "GET",
        success: function (html) {
            Kendo_ShowOrHideLoadingImage("divMain", false);
            if (options != undefined) {
                options.html = html;//we need to set at least this one
                //other options if not specified, would be set to same defaults as when calling ShowModal
                if (!options.hasOwnProperty("isResizable"))
                    options["isResizable"] = true;
                if (!options.hasOwnProperty("hideTitle"))
                    options["hideTitle"] = false;
                if (!options.hasOwnProperty("nonCenteredWindowProperties"))
                    options["nonCenteredWindowProperties"] = null;
                ShowModalWithOptions(options);
            }
            else
                ShowModal(html, true, false, null, useDefaultForMinMaxHeight);
            ReapplyValidatorsOnAddingPartialView();
        },
        error: function (result) {
            Kendo_ShowOrHideLoadingImage("divMain", false);
        }
    });
}

function IsControlActionAlreadyExecuted(ctrl, timeoutMs) {
    try {
        if (timeoutMs == undefined)
            timeoutMs = 4000;
        if (ctrl && typeof (ctrl) === "object" && $(ctrl).length > 0) {
            if ($(ctrl).data("callexecuted"))
                return true;
            $(ctrl).data("callexecuted", true);
            setTimeout(function () {
                $(ctrl).removeData("callexecuted");
            }, timeoutMs);
        }
    }
    catch (err) {
    }
    return false;
}

function ShowModal(html, isResizable, hideTitle, nonCenteredWindowProperties, useDefaultForMinMaxHeight, hideActions, onActvateCallback,
    useReportDefaultsWhenHeightIsAuto, onClose, canMaximize, minHeight, maxHeight, newWidth, newHeight) {

    if (canMaximize == null || canMaximize == undefined || typeof (canMaximize) != "boolean")
        canMaximize = false;
    if (isResizable == null || isResizable == undefined || typeof (isResizable) != "boolean")
        isResizable = false;
    if (useDefaultForMinMaxHeight == null || useDefaultForMinMaxHeight == undefined || typeof (useDefaultForMinMaxHeight) != "boolean")
        useDefaultForMinMaxHeight = false;
    if (useReportDefaultsWhenHeightIsAuto == null || useReportDefaultsWhenHeightIsAuto == undefined || typeof (useReportDefaultsWhenHeightIsAuto) != "boolean")
        useReportDefaultsWhenHeightIsAuto = false;
    if (hideTitle == null || hideTitle == undefined || typeof (hideTitle) != "boolean")
        hideTitle = false;
    if (hideActions == null || hideActions == undefined || typeof (hideActions) != "boolean")
        hideActions = false;
    var centerWindow = true;
    if (nonCenteredWindowProperties != null && nonCenteredWindowProperties != undefined && typeof (nonCenteredWindowProperties) == "object")
        centerWindow = false;
    var wndActions = canMaximize ? ["Maximize", "Close"] : ["Close"];   

    var dialogTitle = hideTitle ? false : $(html).find(".dialogOptions").attr("title");
    var width = newWidth === undefined ? null : newWidth;
    var height = newHeight === undefined ? null : newHeight;
    if (width == null)
         width = $(html).find(".dialogOptions").attr("width");
    if (width == null)
        width = GetPopUpWidth();
    if (height == null)
         height = $(html).find(".dialogOptions").attr("height");
    if (height == null)
        height = "auto";
    if (!centerWindow && nonCenteredWindowProperties.width != null)
        width = nonCenteredWindowProperties.width;
    var minwidth = $(html).find(".dialogOptions").attr("minwidth");
    if (minwidth == null)
        minwidth = width;
    var minH = height;
    var maxH = height;
    if (useDefaultForMinMaxHeight) {
        minH = 50;//kendo default
        maxH = Infinity;//kendo default
    }
    if (!useDefaultForMinMaxHeight && useReportDefaultsWhenHeightIsAuto && height == "auto") {
        minH = 160;
        maxH = 640;
    }

    if (onClose === undefined || onClose === null)
        onClose = function () { };

    //Id of the ModalPopup, if the client not provide it, then use the default one = "popupWindow"
    var uniquePopupId = $(html).find(".dialogOptions").attr("uniquePopupId");
    if (uniquePopupId == null)
        uniquePopupId = "popupWindow";//Default ModalPopup Name

    if ($.inArray(uniquePopupId, popupWindosIds) >= 0) {
        console.log("Already exists a ModalPopup element with the id =" + uniquePopupId);
        //Only continue if the uniquePopupId is the default value
        if (uniquePopupId != "popupWindow")
            return;
    }
    else {
        //Adding the Id to the list if it not exists
        popupWindosIds.push(uniquePopupId);
    }

    if (minHeight != undefined)
        minH = minHeight;
    if (maxHeight != undefined)
        maxH = maxHeight;

    var uniquePopUpWindow = $("<div id='" + uniquePopupId + "' class='popupWindow col-12 col-lg-12'></div>")
        .appendTo("body")
        .kendoWindow({
            width: width,
            minWidth: minwidth,
            modal: true,
            height: height,
            minHeight: minH,
            maxHeight: maxH,
            resizable: isResizable,
            title: dialogTitle,
            visible: false,
            actions: wndActions,
            maximize: function (e) {
                if (!hideTitle && !hideActions) {
                    $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-window-maximize').first().addClass('tmico-arrow-expand tmmaxrestorewnd').text("");
                    $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-window-restore').first().addClass('tmico-arrow-compress tmmaxrestorewnd').text("");
                }
            },
            close: function (e) {
                var canClose = onClose(e);
                if (canClose != undefined && typeof (canClose) == "boolean") {
                    if (!canClose) {
                        e.preventDefault();
                        return false;
                    }
                }
                //TryResetMenuTimer('ShowModal close');
                DestroyKendoWidgets();//Manually destroying Kendo widget here.
                //Remove the Id from the list of popupWindosIds
                popupWindosIds.splice($.inArray(uniquePopupId, popupWindosIds), 1);
                this.destroy();// destroy method tries to remove Dom elements inside the modal. In case of ListBox, kendo's modal instance not able to find ListBox reference and hence causing removeData of null error.

            },
            refresh: function () {
                //To ensure that keeps height and close event work afted a refresh
                var windowHeight = $(window).height() * 0.9;
                if ($('.popupMessage').height() > windowHeight) {
                    $('.popupMessage').height(windowHeight - ($('.dialogFooter').height() + $('.dialogOptions').height()));
                }

                $(".close-button").on("click", function () {
                    CloseModal(uniquePopupId);
                });

                if (!hideTitle && !hideActions) {
                    $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-window-maximize').first().addClass('tmico-arrow-expand tmmaxrestorewnd').text("");
                    $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-window-restore').first().addClass('tmico-arrow-compress tmmaxrestorewnd').text("");
                }

                if (centerWindow)
                    this.center();
            }
        }).data('kendoWindow').content(html);

    if (centerWindow)
        uniquePopUpWindow.center().open();
    else {
        uniquePopUpWindow.bind("open", function (e) {
            this.wrapper.css({ top: nonCenteredWindowProperties.top, left: nonCenteredWindowProperties.left });
        });
        uniquePopUpWindow.open();
    }

    if (!canMaximize) {
        var parWnd = $("#" + uniquePopupId).closest(".k-window");
        if (parWnd.length > 0)
            parWnd.unbind('dblclick');//disable dblclick maximize action
    }

    if (!hideTitle && !hideActions) {
        $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-close').first().addClass('tmico-close tmfatimescircle').text("");
        $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-window-maximize').first().addClass('tmico-arrow-expand tmmaxrestorewnd').text("");
        $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-window-restore').first().addClass('tmico-arrow-compress tmmaxrestorewnd').text("");
    }
    else if (!hideTitle && hideActions)
        $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-window-actions').first().hide();


    if (isResizable) {
        uniquePopUpWindow.bind("resize", function (e) {
            Popup_Resize(e, uniquePopUpWindow, false, centerWindow);
        });
        uniquePopUpWindow.bind("activate", function (e) {
            Popup_Activate(e, uniquePopUpWindow, centerWindow, onActvateCallback);
        });
    }

    $(".close-button").on("click", function () {
        //TryResetMenuTimer('ShowModal closebutton');
        CloseModal(uniquePopupId);
    });
    var windowHeight = $(window).height() * 0.9;
    if ($('.popupMessage').height() > windowHeight) {
        $('.popupMessage').height(windowHeight - ((($('.dialogFooter').length > 0) ? $('.dialogFooter').height() : 0) +
            (($('.dialogOptions').length > 0) ? $('.dialogOptions').height() : 0)));
    }

    if (centerWindow)
        uniquePopUpWindow.center();

    popUpWindow = uniquePopUpWindow;


    // try to reset timer  before returning
    TryResetMenuTimer('ShowModal');

    //popupWindosIds
    return uniquePopUpWindow;
}

function DestroyKendoWidgets() {
    //Needed to destroy Listbox control from Assignments. Kendo window (modal) destroy is not able to find Listbox instance so providing a manual destroy here
    if ($("#AvailableSelections") != null) {
        var avail = $("#AvailableSelections").data("kendoListBox");
        if (avail != null)
            avail.destroy();
    }
    if ($("#AssignedSelections") != null) {
        var assn = $("#AssignedSelections").data("kendoListBox");
        if (assn != null)
            assn.destroy();
    }
}

function ClosePopUpWindow(){
    DestroyKendoWidgets();
    $("#popupWindow").data("kendoWindow").close();
}

function Popup_Activate(arg, popupWindow, centerWindow, onActvateCallback) {
    Popup_Resize(arg, popupWindow, true, centerWindow);
    if (onActvateCallback && typeof (onActvateCallback) == "function")
        onActvateCallback(arg, popupWindow);
}

function Popup_Resize(arg, popupWindow, resizeOnActivation, centerWindow) {
    if (resizeOnActivation == null || resizeOnActivation == undefined || typeof (resizeOnActivation) != "boolean")
        resizeOnActivation = false;
    if (centerWindow == null || centerWindow == undefined || typeof (centerWindow) != "boolean")
        centerWindow = true;

    if ($(".popupMessage").length > 0) {
        var popupWindowHeight = ($(".popupWindowParent").length > 0) ? $(".popupWindowParent").height() : $("#popupWindow").height();
        var offset = ($(".popupWindowParent").length > 0) ? ($(".popupWindowParent .k-window-titlebar").offset().top - $(".popupWindowParent").offset().top) : 0;
        //var buttonsAndTitleHeight = ($(".popupWindowParent").length > 0) ? ($(".popupWindowParent .btn-panel-right").innerHeight() + $(".popupWindowParent .k-window-titlebar").height() - offset) :
        //    ($("#popupWindow .btn-panel-right").innerHeight());
        var buttonsAndTitleHeight = 0;
        if ($(".popupWindowParent").length > 0) {
            if ($(".popupWindowParent .btn-panel-right").length > 0)
                buttonsAndTitleHeight += $(".popupWindowParent .btn-panel-right").innerHeight();
            if ($(".popupWindowParent .k-window-titlebar").length > 0)
                buttonsAndTitleHeight += $(".popupWindowParent .k-window-titlebar").height() - offset;
        }
        else if ($("#popupWindow .btn-panel-right").length > 0)
            buttonsAndTitleHeight = $("#popupWindow .btn-panel-right").innerHeight();
        var newPopupContainerHeight = popupWindowHeight - buttonsAndTitleHeight;
        if ($(".popupMessage").find("div[id$='_RepGridContainerDiv']").length == 1) {
            var gridContainer = $("#" + $(".popupMessage").find("div[id$='_RepGridContainerDiv']")[0].id);
            if (!gridContainer)
                return;

            var gridName = gridContainer.find(".k-grid")[0].id;
            //check that the window doesn't become higher than the container
            var availableHeight = 0;
            if ($("#ReportPageContainerId").length > 0) {
                availableHeight = $("#ReportPageContainerId").height() - 60;
            }
            else if ($("#divMain").length > 0) {
                //availableHeight = $("#divMain").height() + $(".footer").height();//footer
                availableHeight = $("#divMain").height();
                if ($(".footer").length > 0)
                    availableHeight += $(".footer").height();
            }
            if (availableHeight > 0 && availableHeight < popupWindowHeight) {
                popupWindowHeight = availableHeight;
            }

            var newReportPopupContainerHeight = popupWindowHeight - buttonsAndTitleHeight;
            if (typeof (Popup_Resize_CustomResizeForGrid) == "function") {
                Popup_Resize_CustomResizeForGrid(gridContainer, gridName, resizeOnActivation, newPopupContainerHeight, newReportPopupContainerHeight);
            }
            else {
                Popup_Resize_CustomResizeForGrid_Generic(gridContainer, gridName, resizeOnActivation, newPopupContainerHeight, newReportPopupContainerHeight, 5);//TBD_DK: is offset 5 needed?
            }
        }
        else if ($(".popupResizableContainer").length > 0) {
            $(".popupMessage").height(newPopupContainerHeight + (($(".popupWindowParent").length > 0) ? 3 : 0));
        }
    }

    if (resizeOnActivation && centerWindow)
        popUpWindow.center();
}


function Popup_Resize_CustomResizeForGrid_Generic(gridContainer, gridName, resizeOnActivation, newPopupContainerHeight, newReportPopupContainerHeight, offsetY) {
    newReportPopupContainerHeight += offsetY;
    if ($(".popupMessage").length > 0 && $(".popupMessage").parent().find(".dialogFooter").length > 0)//if we have buttons, we have to move them too
        $(".popupMessage").height((resizeOnActivation ? newReportPopupContainerHeight : newPopupContainerHeight) + 3);
    gridContainer.height(newReportPopupContainerHeight);
    ReportingGrid_ResizeGrid(gridName);//we'll ask grid to resize itself
    ReportingGrid_ResizeLastColumnToFillTheGridIfResizingDefined(gridName);
}

$(window).on("resize",function () {
    if (popUpWindow != null)
        popUpWindow.center();
    SizePanel();
    try {
        if (RepositionNotesPanel && typeof (RepositionNotesPanel) == "function")//this will exist in TM only
            RepositionNotesPanel();
    }
    catch (err) {
    }
    ResizeCrfFormContainer();
});

function GetPopUpWidth() {
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();

    if (windowHeight < windowWidth)
        return windowWidth * 0.3;
    else
        return windowWidth * 0.5;
}

$(CommonDocumentReady);

function CommonDocumentReady() {
    var isDirty = SsoRemoveUrlParamWithSingleDigitValueAndCheckIfEqualToOne("isdrt");
    if (isDirty != undefined)
        sessionStorage.IsFormDirty = isDirty;
    SizePanel();
}

//Best to test by going to User Notifications and expanding Custom Notifications and resizing the window
function SizePanel() {
    var windowHeight = $(window).height();
    var panel = $("#mainPanel");
    if (panel.length > 0) {
        var panelBody = $("#mainPanelBody");
        var panelContent = $("#mainPanelContent");
        var panelBottom = panel.offset().top + panel.outerHeight(true);
        var footerHeight = ($("footer").length > 0) ? $("footer").height() : 0;
        var pageBottomMargin = 40 + footerHeight;
        var mainPanelBodyMargin = 36; //panelBodyMargin has a margin of 15
        var footerButtonsHeight = 0;
        var saveCancelDiv = $(".pageSaveCancel");
        if (saveCancelDiv.length > 0)
            footerButtonsHeight = saveCancelDiv.height();
        if (panelBottom + footerButtonsHeight + footerHeight > windowHeight) { //when panel content goes beyond window height
            var newPanelBodyHeight = windowHeight - panel.offset().top - panel.height() - pageBottomMargin - footerButtonsHeight + panelBody.height();
            panelBody.height(newPanelBodyHeight);
        }
        else if (panelContent.height() + mainPanelBodyMargin > panelBody.height()) { //when resizing window or expanding content larger and panelBody has room to exapnd to fit the content without a scrollbar
            while (panelContent.height() + mainPanelBodyMargin > panelBody.height() && !(panelBottom + footerButtonsHeight + pageBottomMargin > windowHeight)) {
                panelBody.height(panelBody.height() + mainPanelBodyMargin / 2);
                panelBottom = panel.offset().top + panel.outerHeight(true);
            }
        }
        else if (panelContent.height() < panelBody.height()) { //when content decreased in size for example by hiding/colapsing some content make panelBody size fit the content with its margin
            panelBody.height(panelContent.height() + mainPanelBodyMargin);
        }
    }
}

function ResizeGridsIfExists() {
    if (typeof (ReportingGrid_ResizeAllReportingGrids) == "function")
        ReportingGrid_ResizeAllReportingGrids();
}

function HideAll(container) {
    var obj = '#' + container;
    $(obj).find('.alert-info').hide();
    $(obj).find('.alert-danger').hide();
    $(obj).find('.alert-warning').hide();
    $(obj).find('.alert-success').hide();
}
function showInfo(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spninfo').html(message);
    $(obj).find('.ulinfo').hide();
    HideAll(container);
    $(obj).find('.alert-info').show();
    //ResizeGridsIfExists(); //kbhat: This is commented since the grids were shrinking after displaying the message.
}
function showMultipleInfoMsg(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spninfo').html(message);
    $(obj).find('.ulinfo').show();
    $(obj).find('.ulinfo').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-info').show();
    ResizeGridsIfExists();
}
function showError(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);        
        return;
    }
    $(obj).find('.spnerror').html(message);
    $(obj).find('.ulerror').hide();
    HideAll(container);
    $(obj).find('.alert-danger').show();
    //ResizeGridsIfExists(); //kbhat: This is commented since the grids were shrinking after displaying the message.
}
function showMultipleErrorMsg(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spnerror').html(message);
    $(obj).find('.ulerror').show();
    $(obj).find('.ulerror').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-danger').show();
    ResizeGridsIfExists();
}
function showWarning(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spnwarning').html(message);
    $(obj).find('.ulwarning').hide();
    HideAll(container);
    $(obj).find('.alert-warning').show();
    //ResizeGridsIfExists(); //kbhat: This is commented since the grids were shrinking after displaying the message.
}
function showMultipleWarning(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spnwarning').html(message);
    $(obj).find('.ulwarning').show();
    $(obj).find('.ulwarning').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-warning').show();
    ResizeGridsIfExists();
}
function showSuccess(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spnsuccess').html(message);
    $(obj).find('.ulsuccess').hide();
    HideAll(container);
    $(obj).find('.alert-success').show();
    //ResizeGridsIfExists(); //kbhat: This is commented since the grids were shrinking after displaying the message.
}
function showMultipleSuccess(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spnsuccess').html(message);
    $(obj).find('.ulsuccess').show();
    $(obj).find('.ulsuccess').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-success').show();
    ResizeGridsIfExists();
}

var notespanelWindow;

function ShowManualQueriesView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId) {
    var npAction = 0/*None*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 1, npAction, GetDefaultExtendedValues());
}
function ShowByPassView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, extValues) {
    var npAction = 2/*AddBypassNote*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 1, npAction, extValues);
}
function ShowChangeHistoryViewAddChangeNoteShowChangeHistoryView(titleText, link, TrlObjectId, TrlObjectFormId, SecAreaId) {
    var npAction = 0/*None*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 3, npAction, GetDefaultExtendedValues());
}
function AddChangeNoteShowChangeHistoryView(titleText, link, TrlObjectId, TrlObjectFormId, SecAreaId) {
    var npAction = 1;/*AddChangeNote*/
    var InstanceNo = -1;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 3, npAction, GetDefaultExtendedValues());
}
function DeleteGroupInstanceShowChangeHistoryView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, npAction, SecAreaId) {
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 3, npAction, GetDefaultExtendedValues());
}
function ShowGeneralNotesView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId) {
    var npAction = 0/*None*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 2, npAction, GetDefaultExtendedValues());
}
function ShowAttachment(link, trlObjectId, trlObjectFormId, viewOnly) {
    var request = $.ajax({
        url: link,
        data:{
                toid:trlObjectId,
                tofid:trlObjectFormId,
                vo:viewOnly
             },
        cache: false,
        method: "Get",
        success: function (html) {
        	var upID = ShowModal(html);
        	if (html.indexOf("IsDispositionAttachment") != -1) { // close popup imemdiatley -> file will be downloaded anyway
        		setTimeout(function () { CloseModelPopup(); }, 1000);
        	}
        },
        error: function (result) {
            alert("Attach Ajax error " + result);
        }
    });
}

function DisplayQuery(TrlObjectQueryId, TrlObjectFormId, title, actionUrl, secAreaId) {
    var npAction = 5/*None*/;
    ShowNotesPanel(HtmlDecode(title), decodeURIComponent(actionUrl), TrlObjectQueryId, TrlObjectFormId, 0, secAreaId, 1, npAction, GetDefaultExtendedValues());
}

function ReapplyValidatorsOnAddingPartialView() {
    $('form').removeData('validator');
    $('form').removeData('unobtrusiveValidation');
    $.validator.unobtrusive.parse('form');
}

function Kendo_ShowOrHideLoadingImage(divElementId, showLoadImage) {
    try {
        if (kendo != undefined && divElementId != undefined && divElementId != null && divElementId != "")
            kendo.ui.progress($("#" + divElementId), showLoadImage);
    }
    catch (err) {
    }
}

function Global_RenderHtmlIntoControl(html, controlId, slowTransition, showControl) {
    if (slowTransition == null || slowTransition == undefined || typeof (slowTransition) != "boolean")
        slowTransition = true;//default
    if (slowTransition) {
        $("#" + controlId).css("visibility", "visible");//reduce flickering
        $("#" + controlId).css("display", "none");//reduce flickering
    }
    $("#" + controlId).empty().html(html);//render
	if (showControl)
		$("#" + controlId).show();
    if (slowTransition)
        $("#" + controlId).fadeIn(350);//reduce flickering
}

function GetEfFectiveWidth() {
    var mainWidth = $('#rootCrf').width();
    var wid = '';
    if (mainWidth > 1199) {
        wid = mainWidth * 0.25;
    }
    if (mainWidth > 991 && mainWidth < 1200) {
        wid = mainWidth * 0.33;
    }
    if (mainWidth > 767 && mainWidth < 992) {
        wid = mainWidth * 0.5;
    }
    if (mainWidth < 768) {
        wid = mainWidth * 1;
    }
    return wid;
}

function Global_getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function Global_setCookie(cname, cvalue, exdays) {
    if (!isNaN(exdays) || exdays == null || exdays < 1)
        document.cookie = cname + "=" + cvalue;
    else {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

function ResizeCrfFormContainer() {
    if (window.ShareCRFForm && window.ShareCRFForm != undefined)
        window.ShareCRFForm.UpdateStateOnResize();
}

function FilterSelection(inputCntrl, optionsCntrl) {
	var filterTxt = inputCntrl.val().toLowerCase();
	if (filterTxt.length < 3) {
		optionsCntrl.each(function () {
			$(this).show();
		});
	}
	else {
		optionsCntrl.each(function () {
			if ($(this).text().toLowerCase().indexOf(filterTxt) == 0)
				$(this).show();
			else
				$(this).hide();
		});
	}
}

//when this function returns false, caller should proceed with custom result handling, otherwise (when returns true) it should not continue with the result processing
//ajaxResult should have the following properties:
//1) result: (string) result code (e.g. 'ERR_PER')
//2) message: (string) display message (if null or empty, it will not display the popup message)
//3) logout: (bool) when true, it will call logout (if popup is displayed, it will logout after popup is closed)
//4) redirectUrl: (string) with URL where user will be redirected (if popup is displayed, it will redirect after popup is closed). logout must be 'false'.
//5) responseText: OPTIONAL (string) containing message details
function AjaxResult_CommonResultHandled(ajaxResult) {
    if (ajaxResult == null || ajaxResult == undefined || ajaxResult.result == null || ajaxResult.result == undefined ||
        (ajaxResult.result != "ERR_PER" && ajaxResult.result != "ERR_6" && ajaxResult.result != "ERR_8")) //6-offline; 8-locked
        return false;

    if (ajaxResult.result == "ERR_6" || ajaxResult.result == "ERR_8") {
        var logoutReason = (ajaxResult.result == "ERR_6") ? 6 : 8;
        Global_CancelAndLogOutWithError(ajaxResult.currentUrlTemplate, logoutReason, ajaxResult.errorMessage, ajaxResult.trialGroupName);
        return true;
    }

    var doLogout = (ajaxResult.logout != null && ajaxResult.logout != undefined && typeof (ajaxResult.logout) == "boolean") ? ajaxResult.logout : false;
    var redirectUrl = (ajaxResult.redirectUrl != null && ajaxResult.redirectUrl != undefined) ? ajaxResult.redirectUrl : "";
    var onFinish = function () {
        if (doLogout)
            Logout();
        else if (redirectUrl != "")
            window.location.replace(redirectUrl);
    };

    if (ajaxResult.message == undefined || ajaxResult.message == null || ajaxResult.message == "") {
        //no popup
        onFinish();
    }
    else {
        //show popup
        ReportGridAjax_ErrorHandler(ajaxResult.message, ajaxResult, onFinish);
    }
    return true;
}

//use Url.Action("zzzACTzzz", "zzzCONTzzz") to create currentPathControllerAction
function Global_CancelAndLogOutWithError(currentPathControllerAction, logoutReason, errorMessage, trialGroupName) {
    if (logoutReason == 0)
        return;//no logout requested
    var ajaxUrl = currentPathControllerAction.replace("zzzACTzzz", "CancelAndLogOutWithError").replace("zzzCONTzzz", "Account");
    var loginUrl = currentPathControllerAction.replace("zzzACTzzz", "Login").replace("zzzCONTzzz", "Account");
    if (window.top.location.href.toLowerCase().indexOf(loginUrl.toLowerCase()) >= 0)
        return;//we're already logged out
    $.ajax({
        data: { logoutReason: logoutReason, errorMessage: errorMessage },
        url: ajaxUrl,
        method: "POST",
        success: function (result) {
            window.top.location.href = (loginUrl + "?tgn=" + encodeURIComponent(HtmlDecode(trialGroupName)) + "&errorMessage=" + encodeURIComponent(HtmlDecode(errorMessage)));
        },
        error: function (result) {
            showAlert("Ajax error navigating away", "Error");
        }
    });
}


function ReportGridAjax_ErrorHandler(message, result, onPopupClose) {
    var errorMessage = ReportGridAjax_GetErrorHandlerMessage(message, result);
    if (errorMessage)
        showErrorPU(errorMessage, "Error", onPopupClose);
}

function ReportGridAjax_GetErrorHandlerMessage(message, result) {
    if (message && result) {
        var additionalText = "";// && result.responseText
        if (result.responseText) {
            if (!result.responseText.toUpperCase().startsWith("<!DOCTYPE HTML>"))
                additionalText = result.responseText;
            else {
                //sometimes unhanded exceptions will return the whole error page - we cannot have that when displaying error in pop-up
                var detErrorIdx = result.responseText.toUpperCase().indexOf('<SPAN CLASS="SPNERROR">');//extract error message from page
                if (detErrorIdx > 0) {
                    var detErrorEndIdx = result.responseText.toUpperCase().indexOf('</SPAN>', detErrorIdx + 23);
                    if (detErrorEndIdx > detErrorIdx)
                        additionalText = result.responseText.substring(detErrorIdx + 23, detErrorEndIdx).trim();
                }
            }
        }
        else if ($.type(result) === "string")
            additionalText = result;
        //result.responseText might be enclosed with header and warning style - remove it
        if (additionalText != "") {
            var msgDetails = additionalText.replace("<h1 ", "<p ").replace("<h2 ", "<p ").replace("<h3 ", "<p ").replace("</h1>", "</p>").replace("</h2>", "</p>").replace("</h3>", "</p>");
            message += "<br/><br/><i>Details:</i><br/>" + msgDetails;
        }
    }
    return message;
}

function LoadIcrf(icrfHref) {
    Kendo_ShowOrHideLoadingImage("divMain", true);
    window.location = icrfHref;
}


function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function processOnFocus(element) {
    var isMobile = $(window).width() < 450 ? true : false;
    if (isMobile)
        $('.footer').hide();
    var container = document.getElementById('divBodyRender');
    container.scrollTop = element.offsetTop - 50;
}
function processOnBlur() {
    var isMobile = $(window).width() < 450 ? true : false;
    if (isMobile)
        $('.footer').show();
}

function TgroupFocus() {
    var element = document.getElementById('txtTrialGroupName');
    processOnFocus(element);
}

function UnameFocus() {
    var element = document.getElementById('txtUsername');
    processOnFocus(element);
}
function PwdFocus() {
    var element = document.getElementById('Password');
    processOnFocus(element);
}

function SsoRemoveUrlParamWithSingleDigitValueAndCheckIfEqualToOne(paramName) {
    var parVal = SsoRemoveUrlParamAndGetValue(paramName);
    if (parVal != undefined)
        return (parVal == '1');
    return parVal;
}

function SsoRemoveUrlParamAndGetValue(paramName) {
    var nPos = -1;
    if (window.location.search)
        nPos = window.location.search.toLowerCase().indexOf(paramName.toLowerCase() + "=");
    if (nPos > -1) {
        var nxtPar = window.location.search.indexOf("&", nPos);
        if (nxtPar < 0)
            nxtPar = window.location.search.length;
        var chVal = window.location.search.substring(nPos + paramName.length + 1, nxtPar);
        var href = window.location.pathname + window.location.search;
        var replTxt = paramName + "=" + chVal;
        href = href.replace('&' + replTxt, '');
        href = href.replace('?' + replTxt + '&', '?');//if there are other params
        href = href.replace('?' + replTxt, '');//if this is the only param
        window.history.replaceState({}, document.title, href);
        return chVal;
    }
    return undefined;
}

function IsFormDirty() {
    if (sessionStorage.IsFormDirty !== undefined && sessionStorage.IsFormDirty != 'undefined' && sessionStorage.IsFormDirty != "null")
        return JSON.parse(sessionStorage.IsFormDirty);
    else {
        ResetFormDirtyFlag();
        return false;
    }
}

function SetFormDirtyFlag() {
    sessionStorage.IsFormDirty = true;
}

function ResetFormDirtyFlag() {
    Kendo_ShowOrHideLoadingImage("ButtonRenderer", false);
    sessionStorage.IsFormDirty = false;
}

function GetUrlFromAjaxUrlTemplate(ajaxUrlTemplate, urlController, urlAction, defaultUrl) {
    //defaultUrl will be returned if ajaxUrlTemplate is not specified
    var ajaxUrl = null;
    if (defaultUrl != undefined)
        ajaxUrl = defaultUrl;
    if (ajaxUrlTemplate != undefined && ajaxUrlTemplate != null &&
        urlController != undefined && urlController != null &&
        urlAction != undefined && urlAction != null) {
        if (ajaxUrlTemplate.indexOf("___ACT___") >= 0 || ajaxUrlTemplate.indexOf("___CONT___") >= 0)
            ajaxUrl = ajaxUrlTemplate.replace("___ACT___", urlAction).replace("___CONT___", urlController);
        else if (ajaxUrlTemplate.indexOf("zzzACTzzz") >= 0 || ajaxUrlTemplate.indexOf("zzzCONTzzz") >= 0)
            ajaxUrl = ajaxUrlTemplate.replace("zzzACTzzz", urlAction).replace("zzzCONTzzz", urlController);
        else
            ajaxUrl = ajaxUrlTemplate;
    }
    return ajaxUrl;
}

function CreateArguments(callBackFunction, startFrom, argumentsObject) {
    var callBack = callBackFunction + "(";
    for (var i = startFrom; i < argumentsObject.length; i++) {
        if (typeof (argumentsObject[i]) == "string")
            callBack += "'" + argumentsObject[i] + "',";//only strings should be enclosed with quotes - for null, undefined and boolean, quotes would change the variable type
        else
            callBack += argumentsObject[i] + ",";
    }
    if (callBack.substring(callBack.length - 1, callBack.length) == ",")
        callBack = callBack.substring(0, callBack.length - 1);//remove ','
    callBack += ")";
    return callBack;
}  

function ShowModalWithOptions(options) {
    var html = null;
    var isResizable = null;
    var hideTitle = null;
    var nonCenteredWindowProperties = null;
    var useDefaultForMinMaxHeight = null;
    var hideActions = null;
    var onActvateCallback = null;
    var useReportDefaultsWhenHeightIsAuto = null;
    var onClose = null;
    var canMaximize = undefined;
    var minHeight = undefined;
    var maxHeight = undefined;
    var width = undefined;
    var height = undefined;

    if (options.html !== undefined)
        html = options.html;

    if (options.isResizable !== undefined)
        isResizable = options.isResizable;

    if (options.hideTitle !== undefined)
        hideTitle = options.hideTitle;

    if (options.nonCenteredWindowProperties !== undefined)
        nonCenteredWindowProperties = options.nonCenteredWindowProperties;

    if (options.useDefaultForMinMaxHeight !== undefined)
        useDefaultForMinMaxHeight = options.useDefaultForMinMaxHeight;

    if (options.hideActions !== undefined)
        hideActions = options.hideActions;

    if (options.onActvateCallback !== undefined)
        onActvateCallback = options.onActvateCallback;

    if (options.useReportDefaultsWhenHeightIsAuto !== undefined)
        useReportDefaultsWhenHeightIsAuto = options.useReportDefaultsWhenHeightIsAuto;

    if (options.onClose !== undefined)
        onClose = options.onClose;

    if (options.hasOwnProperty("canMaximize"))
        canMaximize = options.canMaximize;

    if (options.hasOwnProperty("minHeight"))
        minHeight = options.minHeight;

    if (options.hasOwnProperty("maxHeight"))
        maxHeight = options.maxHeight;
    if (options.width !== undefined)
        width = options.width;
    if (options.height !== undefined)
        height = options.height;


    return ShowModal(html, isResizable, hideTitle, nonCenteredWindowProperties, useDefaultForMinMaxHeight, hideActions, onActvateCallback,
        useReportDefaultsWhenHeightIsAuto, onClose, canMaximize, minHeight, maxHeight, width, height);
}

function OpenWindowWithParamsByForm(winUrl, winTarget, arrParamsDetails) {
    //IMPORTANT: 
    //1) winUrl might need '/' at the end when controller and action are not specified
    //2) arrParamsDetails is array of objects describing the hidden parameters. 
    //   - Hidden parameters object has properties "Name" and "Value". 
    //   - "Name" should contain the name of the parameter which you have in your controller action method 
    //     which would be executed when winUrl is opened (e.g. "userName").
    //   - "Value" should contain the value that will be passed to the action method parameter
    //     (it should be encoded if any special character are possible).
    //3) winTarget is the "target" parameter of the opened window (it will be used as window caption)
    //4) Make sure that you don't mix the protocols of current page and new (opened) page. 
    //   Protocol might be defined in MasterAppConfigOptions

    //check for mixed context 
    var currProt = location.protocol;
    if (currProt.length > 0 && winUrl.indexOf("://") > 0) {
        var newProt = (new URL(winUrl)).protocol;
        if (currProt.toLowerCase() != newProt.toLowerCase()) {
            ReportGridAjax_ErrorHandler("Mixed Content Error: You are trying to open a new page using '" + newProt + "' protocol but the current page is loaded using '" + currProt + "' protocol. Please contact Administrator.");
            return;
        }
    }

    //Hidden Form
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", winUrl);
    if (winTarget != undefined)
        form.setAttribute("target", winTarget);

    //Hidden Field
    for (var i = 0; i < arrParamsDetails.length; i++) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("id", arrParamsDetails[i].Name);
        hiddenField.setAttribute("name", arrParamsDetails[i].Name);
        hiddenField.setAttribute("value", arrParamsDetails[i].Value);
        form.appendChild(hiddenField);
    }
    try {
        TryResetMenuTimer('open window');
        document.body.appendChild(form);
        form.submit();
    }
    catch (e) {
        ReportGridAjax_ErrorHandler(e);
    }
}

/// ensure it all fits on screen with scrollbar
function SetContainerMaxHeight() {
    var windowHgt = $(window).height();
    var valHeight = ($("#ValidationInfoContainer").length > 0) ? $("#ValidationInfoContainer").height() : 0;
    var titleHeight = ($("#divPageTitle").length > 0) ? $("#divPageTitle").height() : 0;
    var funMsgHeight = ($("#funmsg").length > 0) ? $("#funmsg").height() : 0;
    var languageSelectorHeight = ($("#LanguageSelector").length > 0) ? $("#LanguageSelector").height() : 0;
    var footerHgt = ($(".footer").length > 0) ? $(".footer").height() : 0;
    var newHgt = windowHgt - languageSelectorHeight - (footerHgt * 2) - funMsgHeight - 2 * valHeight - titleHeight - 125;
    if (newHgt < 50)
        newHgt = 50;

    $("#MainContainer").css('max-height', newHgt);
}
